import { createCompoundComponent } from '../../utilities'

import { CheckboxGroup as CheckboxGroupRoot } from './CheckboxGroup'
import { Item } from './Item'

export const CheckboxGroup = createCompoundComponent(CheckboxGroupRoot, {
  Item,
})
